import { Injectable } from '@angular/core';
import { HttpService } from "./http.service";
import { Router } from "@angular/router";
import { LoggedInUser } from "../models/user";
import { UserDataStoreService } from "./user-data-store.service";
import { debug } from 'util';

@Injectable({
  providedIn: 'root'
})
export class AccountConfirmService {


  constructor(
    private _httpService: HttpService,
    private _router: Router,
    private _userDataStore: UserDataStoreService
  ) {

  }

  public async confirm(password: string, email: string, token: string): Promise<{ success: boolean, message: string }> {
    const httpResult = await this._httpService.apiPost<{ success: boolean, message: string }>(`UserManagement/ConfirmAccount`, {
      Password: password,
      Token: token,
      Email: email
    });

    if (httpResult && httpResult.body.success === true) {
      return httpResult.body;
    }
    else {
      return httpResult.body;
    }
  }
}
